import React from 'react';

import LoadingSpinner from '../../components/LoadingSpinner';
import contrastYIQ from '../../utils/contrastYIQ';
import { IWidgetBlockComponent } from '../types/IWidgetBlock';
import { Container, StyleFooterImg } from './Footer.style';
import { FooterModel } from './types';

const FooterComponent: React.FC<IWidgetBlockComponent<FooterModel>> = ({ widgetModel }) => {
    if (!widgetModel) {
        return <LoadingSpinner />;
    }

    const {
        settings,
        settings: { fontSize, imageSrc },
    } = widgetModel;

    const text = settings.text?.length ? settings.text : `${settings.topText}\n${settings.bottomText}`;
    const textLines = text.split('\n');
    const backgroundColor = settings.backgroundColor || '#16161d';
    const fontColor = contrastYIQ(backgroundColor);

    const textWidth = imageSrc ? '80%' : '100%';
    const textAlign = imageSrc ? 'left' : 'center';

    return (
        <Container className='footerRender' fontSize={fontSize} color={fontColor} backgroundColor={backgroundColor}>
            <div style={{ width: textWidth }}>
                {textLines.map((textLine, i) => (
                    <div style={{ textAlign: textAlign }} key={i}>
                        {textLine}
                        {'\u00A0'}
                    </div>
                ))}
            </div>
            {imageSrc && (
                <StyleFooterImg>
                    <img src={imageSrc} />
                </StyleFooterImg>
            )}
        </Container>
    );
};

export default FooterComponent;
